import { produce } from 'immer';
import { Clip } from './types';
import { create } from 'zustand';

export type ClipState = {
  clip: Clip;
  isFetching: boolean;
  fetchError: string | null;
  fetchStarted: () => void;
  fetchEnded: () => void;
  fetchFailed: (reason: string) => void;
  clipLoaded: (clip: Clip) => void;
  incrementView: (views: number) => void;
  pushComment: (comment: Clip['comments'][number]) => void;
  deleteComment: (commentId: string) => void;
  pushReaction: (reaction: Clip['reactions'][number]) => void;
};

export type ClipStore = ReturnType<typeof createStore>;

export const createStore = () => {
  return create<ClipState>(set => {
    return {
      isFetching: false,
      fetchError: null,
      clip: {
        id: '',
        eventId: '',
        title: '',
        status: '',
        thumbnailUrl: '',
        videoUrl: '',
        createdAt: '',
        views: 0,
        duration: 0,
        meetingTitle: '',
        owner: '',
        ownerId: '',
        isOwner: false,
        host: '',
        comments: [],
        transcript: [],
        reactions: [],
      },
      fetchFailed: reason => set({ fetchError: reason, isFetching: false }),
      fetchStarted: () => set({ isFetching: true }),
      fetchEnded: () => set({ isFetching: false }),
      clipLoaded: clip => set({ clip }),
      incrementView: (views: number) => {
        set(state =>
          produce(state, draft => {
            draft.clip.views = views;
          }),
        );
      },
      pushComment: (comment: Clip['comments'][number]) => {
        set(state =>
          produce(state, draft => {
            draft.clip.comments.push(comment);
          }),
        );
      },
      deleteComment: (commentId: string) => {
        set(state =>
          produce(state, draft => {
            draft.clip.comments = draft.clip.comments.filter(comment => comment.id !== commentId);
          }),
        );
      },
      pushReaction: (reaction: Clip['reactions'][number]) => {
        set(state =>
          produce(state, draft => {
            draft.clip.reactions.push(reaction);
          }),
        );
      },
    };
  });
};
